import { AfterViewInit, Component, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-properties-single',
  templateUrl: './properties-single.component.html',
  styleUrls : ['./properties-single.component.css']
})
export class PropertiesSingleComponent implements AfterViewInit, OnInit {

  constructor(public shared: SharedService) {
    this.shared.isWhiteMenu = true;
  }

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    this.shared.includeMainScript();
  }

}
